export default "__VITE_ASSET__DDWzPxTk__"